import React from 'react';
import { Stack, Container } from '@fiverr-private/layout_components';
import { Heading, Text } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import type { Gql } from '@fiverr-private/dynamic_matching';

interface ScreeningQuestionsProps {
  screeningQuestions: NonNullable<Gql.DmBrief['screeningQuestions']>;
  scope: 'seller' | 'buyer';
}

export const ScreeningQuestions: React.FC<ScreeningQuestionsProps> = ({ screeningQuestions, scope }) => (
  <Stack direction="column" gap="4">
    <Stack direction="column" gap="1">
      <Heading size="h_xxs">
        {translate(`brief_preview_drawer.person_brief.screening_questions.title.${scope}`)}
      </Heading>
      {scope === 'seller' && (
        <Text size="b_sm" color="bodySecondary">
          {translate(`brief_preview_drawer.person_brief.screening_questions.subtitle.${scope}`)}
        </Text>
      )}
    </Stack>
    {/* @ts-expect-error - as="ol" is not a valid prop for Stack */}
    <Stack as="ol" direction="column" gap="2" paddingLeft="5" style={{ listStyleType: 'decimal' }}>
      {screeningQuestions.map((item) => (
        <Container key={item.id} as="li" fontSize="b_md" color="bodyPrimary">
          {item.question}
        </Container>
      ))}
    </Stack>
  </Stack>
);
